<main class="c-main">
  <div class="container-fluid">
    <div class="mat-elevation-z8">
      <mat-card>
        <div class="wow-form-header">
          <div class="wow-form-header__icon"><mat-icon>widgets</mat-icon></div>
          <mat-card-title>
            Funcionalidade
            <span *ngIf="formulario?.value?.id"> — ID {{ formulario.value.id }}</span>
          </mat-card-title>
        </div>

        <p *ngIf="carregando">Carregando...</p>

        <mat-card *ngIf="formulario && !carregando">
          <form [formGroup]="formulario" (ngSubmit)="submit()">
            <div class="row">
              <div class="col-12 col-md-2">
                <mat-form-field appearance="fill" class="full-width">
                  <mat-label>Segmento</mat-label>
                  <mat-select formControlName="segmentoId" required>
                    <mat-option *ngFor="let seg of segmentos" [value]="seg.id">{{ seg.nome }}</mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
              <div class="col-12 col-md-2">
                <mat-form-field appearance="fill" class="full-width">
                  <mat-label>Descrição</mat-label>
                  <input matInput formControlName="descricao" required>
                </mat-form-field>
              </div>
              <div class="col-12 col-md-2">
                <mat-form-field appearance="fill" class="full-width">
                  <mat-label>Value</mat-label>
                  <input matInput formControlName="value" placeholder="Identificador / código">
                </mat-form-field>
              </div>
              <div class="col-12 col-md-2">
                <mat-form-field appearance="fill" class="full-width">
                  <mat-label>Venda avulsa</mat-label>
                  <mat-select formControlName="vendaAvulsa">
                    <mat-option [value]="true">Sim</mat-option>
                    <mat-option [value]="false">Não</mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
              <div class="col-12 col-md-2" *ngIf="formulario.value.vendaAvulsa === true">
                <mat-form-field appearance="fill" class="full-width">
                  <mat-label>Valor</mat-label>
                  <input matInput formControlName="valor" currencyMask
                    [options]="{ prefix: 'R$ ', thousands: '.', decimal: ',', align: 'left', allowNegative: false }">
                </mat-form-field>
              </div>
              <div class="col-12 col-md-2">
                <mat-form-field appearance="fill" class="full-width">
                  <mat-label>Situação</mat-label>
                  <mat-select formControlName="ativo">
                    <mat-option [value]="true">Ativo</mat-option>
                    <mat-option [value]="false">Inativo</mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
            </div>

            <div class="wow-form-acoes">
              <button type="button" mat-stroked-button (click)="voltarConsulta()">
                <mat-icon>arrow_back</mat-icon> Voltar
              </button>
              <button type="button" mat-stroked-button (click)="limpar()">
                <mat-icon>clear</mat-icon> Limpar
              </button>
              <button type="submit" mat-raised-button color="primary" [disabled]="formulario.invalid">
                <mat-icon>save</mat-icon> Salvar
              </button>
            </div>
          </form>
        </mat-card>
      </mat-card>
    </div>
  </div>
</main>
